import type { CellCoordinates, Navigation } from './GridField.model';

interface GridInfos {
  gridId: string;
  nbRows: number;
  nbColumns: number;
}

export function buildCellId(gridId: string, columnIndex: number, rowIndex: number) {
  return `${gridId}-${rowIndex}-${columnIndex}`;
}

export function buildCellIds(
  gridId: string,
  rowIndexStart: number,
  columnIndexStart: number,
  rowIndexEnd: number,
  columnIndexEnd: number,
) {
  const columnStart = Math.min(columnIndexStart, columnIndexEnd);
  const columnEnd = Math.max(columnIndexStart, columnIndexEnd);
  const rowStart = Math.min(rowIndexStart, rowIndexEnd);
  const rowEnd = Math.max(rowIndexStart, rowIndexEnd);

  const cellIds: string[] = [];
  for (let col = columnStart; col <= columnEnd; col++) {
    for (let row = rowStart; row <= rowEnd; row++) {
      cellIds.push(buildCellId(gridId, col, row));
    }
  }
  return cellIds;
}

export type ClippingFunc = (destination: CellCoordinates, navigation: Navigation) => CellCoordinates;

export const clippingWithGrid = (gridInfos: GridInfos) => (destination: CellCoordinates, navigation: Navigation) => {
  if (destination.column < 0) {
    if (navigation === 'previous') {
      destination.row = destination.row - 1;
      destination.column = gridInfos.nbColumns - 1;
    } else {
      destination.column = 0;
    }
  }
  if (destination.column >= gridInfos.nbColumns) {
    if (navigation === 'next') {
      destination.row = destination.row + 1;
      destination.column = 0;
    } else {
      destination.column = gridInfos.nbColumns - 1;
    }
  }
  if (destination.row < 0) {
    destination.row = 0;
  }
  if (destination.row >= gridInfos.nbRows) {
    if (navigation === 'next') {
      destination.row = 0;
    } else if (navigation === 'down') {
      destination.row = 0;
      destination.column = (destination.column + 1) % gridInfos.nbColumns;
    } else {
      destination.row = gridInfos.nbRows - 1;
    }
  }
  return destination;
};
export function nextCellCoordinates(
  origin: CellCoordinates,
  navigation: Navigation,
  clipping: ClippingFunc,
): CellCoordinates {
  const destination: CellCoordinates = { ...origin };

  switch (navigation) {
    case 'up':
      {
        destination.row = destination.row - 1;
      }
      break;
    case 'down':
      {
        destination.row = destination.row + 1;
      }
      break;
    case 'previous':
    case 'left':
      {
        destination.column = destination.column - 1;
      }
      break;
    case 'next':
    case 'right':
      {
        destination.column = destination.column + 1;
      }
      break;
  }

  return clipping(destination, navigation);
}
